import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import MemberAPIClient from "../client/MemberAPIClient";
import EmailVerificationAPIClient from "../client/EmailVerificationAPIClient";
import PhoneNumberVerificationAPIClient from "../client/PhoneNumberVerificationAPIClient";

class MemberActions {

    constructor() {
        this.memberApiClient = new MemberAPIClient();
        this.emailVerificationApiClient = new EmailVerificationAPIClient();
        this.phoneNumberVerificationApiClient = new PhoneNumberVerificationAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.RENDERED_VIEW_REQUIRES_MEMBER, this.handleMemberRequired);
        EventPublisher.subscribe(UIInteractionEvents.EMAIL_VERIFICATION_EMAIL_REQUESTED, this.handleVerificationEmailRequested);
        EventPublisher.subscribe(UIInteractionEvents.EMAIL_VERIFICATION_CHECK_SUBMITTED, this.handleEmailVerificationCheck);
        EventPublisher.subscribe(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_SMS_REQUESTED, this.handleVerificationSMSRequested);
        EventPublisher.subscribe(UIInteractionEvents.PHONE_NUMBER_VERIFICATION_CHECK_SUBMITTED, this.handlePhoneVerificationCheck)

    }

    handleMemberRequired = (topic, data) => {
        this.memberApiClient.getMember();
    };

    handleVerificationEmailRequested = (topic, data) => {
        this.emailVerificationApiClient.requestEmail()
    };

    handleEmailVerificationCheck = (topic, data) => {
        this.emailVerificationApiClient.checkCode(data.validationCode);
    };

    handleVerificationSMSRequested = (topic, data) => {
        this.phoneNumberVerificationApiClient.requestSMS()
    };

    handlePhoneVerificationCheck = (topic, data) => {
        this.phoneNumberVerificationApiClient.checkCode(data.validationCode);
    };


}

export default new MemberActions();
